import ToggleTabs from "../components/ToggleTabs";
import CompanyUsers from "../containers/CompanyUsers";

export default function CompanyUsersPage() {
  return (
    <ToggleTabs>
      <CompanyUsers />
    </ToggleTabs>
  );
}
